import {DataTableBulkSelectorConfig, RecordedEntryDataTableBulkSelector} from "@/shared/ui/dataTableBulkSelector";
import {DriveLogUserSums, ReportDriveLog} from "@/shared/timr";

export class DriveLogBulkSelector extends RecordedEntryDataTableBulkSelector<ReportDriveLog> {

	protected distanceSum = 0;
	protected distanceBusinessSum = 0;
	protected distancePrivateSum = 0;
	protected allSelectedDistanceSum = 0;
	protected allSelectedDistanceBusinessSum = 0;
	protected allSelectedDistancePrivateSum = 0;

	constructor(public config: DataTableBulkSelectorConfig) {
		super(config);
	}

	protected override sumAdditionalParams(recording: ReportDriveLog, subtract: boolean) {
		if (recording.distance) {
			const distance = subtract ? -recording.distance : recording.distance;
			this.distanceSum += distance;
			if (recording.category?.business) {
				this.distanceBusinessSum += distance;
			} else {
				this.distancePrivateSum += distance;
			}
		}
	}

	protected override onRecordDataChanged(recording: ReportDriveLog) {
		super.onRecordDataChanged(recording);
		const old = this.entries.get(recording.id).recording;
		if (old.distance !== recording.distance) {
			this.sumAdditionalParams(old, true);
			this.sumAdditionalParams(recording, false);
		}
	}

	protected initAllSelectedSum(dataTableJsonData: { driveLogSums?: DriveLogUserSums }) {
		if (dataTableJsonData.driveLogSums) {
			const driveLogBusinessSums = dataTableJsonData.driveLogSums.businessSums;
			const driveLogPrivateSums = dataTableJsonData.driveLogSums.privateSums;
			this.allSelectedDurationNetSum = driveLogBusinessSums.durationNet + driveLogPrivateSums.durationNet;
			this.allSelectedDistanceSum = driveLogBusinessSums.distance + driveLogPrivateSums.distance;
			this.allSelectedDistanceBusinessSum = driveLogBusinessSums.distance;
			this.allSelectedDistancePrivateSum = driveLogPrivateSums.distance;
		}
	}

	public override getSums() {
		return {
			...super.getSums(),
			distanceSum: this.distanceSum,
			distanceBusinessSum: this.distanceBusinessSum,
			distancePrivateSum: this.distancePrivateSum
		};
	}

	protected override resetSums() {
		super.resetSums();
		this.distanceSum = 0;
		this.distanceBusinessSum = 0;
		this.distancePrivateSum = 0;
	}

	protected override setAllSelectedSums() {
		super.setAllSelectedSums();
		this.distanceSum = this.allSelectedDistanceSum;
		this.distanceBusinessSum = this.allSelectedDistanceBusinessSum;
		this.distancePrivateSum = this.allSelectedDistancePrivateSum;
	}
}
